import { Item } from "../../pojo/Item";
import { TelemetrySession } from "../../services/telemetry/telemetry.session";
import { Search } from "./search";

export const SEARCH_CATEGORY = "Search";

export type SearchAvailabilityFeature =
    | "EventAvailability"
    | "LocationAvailability"
    | "LocationAvailabilityWeekly"
    | "ResourceAvailability";

const availabilityFeatureByTypeId: Partial<Record<Item.Id, SearchAvailabilityFeature>> = {
    [Item.Ids.Event]: "EventAvailability",
    [Item.Ids.Location]: "LocationAvailability",
    [Item.Ids.Resource]: "ResourceAvailability",
};

export class SearchTelemetry {
    static createAvailabilitySession(feature: SearchAvailabilityFeature): TelemetrySession {
        return new TelemetrySession(SEARCH_CATEGORY, feature);
    }

    static availabilitySession(typeId: Item.Id, tab: Search.Tab): TelemetrySession | undefined {
        if (tab === "availability") {
            const feature = availabilityFeatureByTypeId[typeId];
            return feature ? SearchTelemetry.createAvailabilitySession(feature) : undefined;
        }
        if (tab === "availabilityWeekly" && typeId === Item.Ids.Location) {
            return SearchTelemetry.createAvailabilitySession("LocationAvailabilityWeekly");
        }
    }
}
